import { select } from 'typed-redux-saga/macro';

import config from 'Config';
import { withErrorHandling } from 'Lib/sagaHelpers';
import fetch from 'Lib/utils/fetch';

import { getContextLanguage, getOsFamilyAndVersion } from 'Store/context/selectors';
import { getCurrentLanguage } from 'Store/internationalization/selectors';
import {
  getHasGoldSubscription,
  getHasPremiumSubscription,
  getHasSubscription,
} from 'Store/profile/revenue.selectors';
import {
  getProfileFacebookEmail,
  getProfileUserId,
  getVerifiedEmail,
} from 'Store/profile/selectors';

export const setHelpFormCookies = withErrorHandling(
  function* _setHelpFormCookies() {
    const cLoc = yield* select(getContextLanguage);
    const userId = yield* select(getProfileUserId);
    const os = yield* select(getOsFamilyAndVersion);
    const language = yield* select(getCurrentLanguage);
    const fbEmail = yield* select(getProfileFacebookEmail);
    const verifiedEmail = yield* select(getVerifiedEmail);
    const hasSub = yield* select(getHasSubscription);
    const hasGold = yield* select(getHasGoldSubscription);
    const hasPremiumSubscription = yield* select(getHasPremiumSubscription);
    const hasPlus = hasSub && !hasPremiumSubscription;

    yield fetch('/contact/request?redirect=0', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        d: config.helpForm.devicePlatform,
        os,
        ti: process.env.VERSION,
        u: userId,
        loc: cLoc,
        locale: language,
        p: hasPlus,
        g: hasGold,
        fbe: fbEmail || verifiedEmail,
      }),
    });
  },
  {
    name: 'setHelpFormCookies',
  }
);
